export default __webpack_public_path__ + "static/media/img2.780bb354.jpg";